import React from 'react'

const Faq = () => {
  return (
    <div>
        <div className="container-fluid bg-light myfont1">
            <h2 className='text-center pt-4 mb-4 fw-bold'>Top Reasons to Join Fortune Cloud's Training :</h2>

            <div className="container">
                <div className='text-start border border-secondary border-2 p-2 mb-2'>
                    <strong><i className="bi bi-check"></i> Fortune Cloud - A subsidiary of Cravita Technologies India Private Limited</strong>
                    which is one of the leading Information Technology Consulting, Services and Outsourcing organization.
                </div>
                <div className='text-start border border-secondary border-2 p-2 mb-2'>
                    <i className="bi bi-check"></i> Job Enabling Training Program - Training by IT Professionals. With 5+ Years Real -Time experienced Faculty.
                </div>
                <div className='text-start border border-secondary border-2 p-2 mb-2'>
                    <i className="bi bi-check"></i> Live Project Exposure - Real Time Work Experience ensures you get the much required Professional IT Experience in IT & ITES industry.
                </div>
                <div className='text-start border border-secondary border-2 p-2 mb-2'>
                    <i className="bi bi-check"></i> All Our Centers Are Equipped With Modern Teaching Aids Such As Smart Boards With Live Recording Facilities, Wi-fi, And Overhead Projectors.
                </div>
                <div className='text-start border border-secondary border-2 p-2 mb-2'>
                    <i className="bi bi-check"></i> 100% Placement Assurance
                </div>
            </div><br></br>
            
        </div>




        
        <div className="container-fluid bg-light mb-2 myfont1">
            <h2 className='text-center pt-4 mb-4 fw-bold'>FAQ`s</h2>
            <div className="container">
                {/* <h2 className="mb-4 text-center">Frequently Asked Questions</h2> */}
                <div className="accordion" id="faqAccordion">

                {/* FAQ 1 */}
                <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="faq1-heading">
                    <button className="accordion-button collapsed border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#faq1" aria-expanded="true" aria-controls="faq1">
                    What is Strength of the Batch ?
                    <span className="toggle-icon ms-auto"></span>
                    </button>
                </h2>
                <div id="faq1" className="accordion-collapse collapse" aria-labelledby="faq1-heading" data-bs-parent="#faqAccordion">
                    <div className="accordion-body text-start">
                    Min 25 to max 50+ (Depends on Courses).
                    </div>
                </div>
                </div>

                {/* FAQ 2 */}
                <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="faq2-heading">
                    <button className="accordion-button collapsed border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#faq2" aria-expanded="false" aria-controls="faq2">
                    What is average package that a fresher can get ?
                    <span className="toggle-icon ms-auto"></span>
                    </button>
                </h2>
                <div id="faq2" className="accordion-collapse collapse" aria-labelledby="faq2-heading" data-bs-parent="#faqAccordion">
                    <div className="accordion-body text-start">
                    On an Average min 2.5 LPA to 5 LPA (can extend upto 8 LPA+).
                    </div>
                </div>
                </div>

                {/* FAQ 3 */}
                <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="faq3-heading">
                    <button className="accordion-button collapsed border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#faq3" aria-expanded="false" aria-controls="faq3">
                    Do You take aptitude Training?
                    <span className="toggle-icon ms-auto"></span>
                    </button>
                </h2>
                <div id="faq3" className="accordion-collapse collapse" aria-labelledby="faq3-heading" data-bs-parent="#faqAccordion">
                    <div className="accordion-body text-start">
                    No, we don't teach aptitude but we conduct test series for practice of the same along with Mock Intervies & CV prepartions.
                    </div>
                </div>
                </div>

                {/* FAQ 4 */}
                <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="faq4-heading">
                    <button className="accordion-button collapsed border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#faq4" aria-expanded="false" aria-controls="faq4">
                    Is there any difference in online and offline batch?
                    <span className="toggle-icon ms-auto"></span>
                    </button>
                </h2>
                <div id="faq4" className="accordion-collapse collapse" aria-labelledby="faq4-heading" data-bs-parent="#faqAccordion">
                    <div className="accordion-body text-start">
                    The only difference is, for online training - you attend the class from your home without a mentor monitoring you and for offline training - the mentor can monitor you face to face!
                    </div>
                </div>
                </div>

                {/* FAQ 5 */}
                <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="faq5-heading">
                    <button className="accordion-button collapsed border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#faq5" aria-expanded="false" aria-controls="faq5">
                    Is there any test/exam after the course completion?
                    <span className="toggle-icon ms-auto"></span>
                    </button>
                </h2>
                <div id="faq5" className="accordion-collapse collapse" aria-labelledby="faq5-heading" data-bs-parent="#faqAccordion">
                    <div className="accordion-body text-start">
                    Yes, but not at the end. We would start conducting the exams in terms of theory, Practical & oral after every module you learn. Total there would be 600-700 marks test till the end of the course (Depends on the course as well).
                    </div>
                </div>
                </div>

                {/* FAQ 6 */}
                <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="faq6-heading">
                    <button className="accordion-button collapsed border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#faq6" aria-expanded="false" aria-controls="faq6">
                    How are the Company Interviews Scheduled (Online/Offline)
                    <span className="toggle-icon ms-auto"></span>
                    </button>
                </h2>
                <div id="faq6" className="accordion-collapse collapse" aria-labelledby="faq6-heading" data-bs-parent="#faqAccordion">
                    <div className="accordion-body text-start">
                    It completely depends on the Company.
                    </div>
                </div>
                </div>

                {/* FAQ 7 */}
                <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="faq7-heading">
                    <button className="accordion-button collapsed border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#faq7" aria-expanded="false" aria-controls="faq7">
                    How many rounds are conducted in the interview?
                    <span className="toggle-icon ms-auto"></span>
                    </button>
                </h2>
                <div id="faq7" className="accordion-collapse collapse" aria-labelledby="faq7-heading" data-bs-parent="#faqAccordion">
                    <div className="accordion-body text-start">
                    Usually there are 1-3 rounds, can increase beyond that depending on the expertise the company needs.
                    </div>  
                </div>
                </div>

                {/* FAQ 8 */}
                <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="faq8-heading">
                    <button className="accordion-button collapsed border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#faq8" aria-expanded="false" aria-controls="faq8">
                    How Many Interview Calls Will be Provided?  
                    <span className="toggle-icon ms-auto"></span>
                    </button>
                </h2>
                <div id="faq8" className="accordion-collapse collapse" aria-labelledby="faq8-heading" data-bs-parent="#faqAccordion">
                    <div className="accordion-body text-start">
                    Unlimited Interview Calls Until You Get a Job.
                    </div>
                </div>
                </div>

            </div>
            </div><br></br>
        </div>
        </div>
  )
}

export default Faq